import {FormEvent, useState} from "react";
import {getCurrentDateInSeconds} from "../../../../../../shared/functions/getRandomId";
import {useUserStore} from "../../../../../../../modules/shop/user/store";
import {CardHead, SpinButton, withMinSpin} from "../../../../components/ProfileCard/ProfileCard";

const STEAM_ID = /^7656\d{13}$/;

const TransferBlock = ({ fetchTransfers, createTransfer, setDataForToaster, fetchUser }) => {
    const [amount, setAmount] = useState("100")
    const [steamId, setSteamId] = useState("")
    const [loading, setLoading] = useState(false)
    const balance = Number(useUserStore(s => s.user)?.balance ?? 0)

    const warn = (message: string) => setDataForToaster({ message, type: "warning", id: getCurrentDateInSeconds() })

    const submit = async (e: FormEvent) => {
        e.preventDefault()
        if (loading) return

        const sum = Number(amount)
        const recipient = steamId.trim()
        if (!Number.isFinite(sum) || sum <= 0) return warn("Вкажіть суму переказу")
        if (!STEAM_ID.test(recipient)) return warn("SteamID — це 17 цифр, що починаються з 7656")

        setLoading(true)
        await withMinSpin(() => createTransfer(sum, recipient, setDataForToaster, setAmount, setSteamId, fetchUser))
        setLoading(false)
        fetchTransfers(1)
    }

    return (
        <form className="bc-card" onSubmit={submit}>
            <CardHead
                icon={
                    // монета з гривнею, що «відлітає» стрілкою — переказ грошей
                    <svg width="42" height="42" viewBox="0 0 24 24">
                        <circle cx="9.5" cy="12" r="7.5" fill="#fff" />
                        <text x="9.5" y="15.6" textAnchor="middle" fontSize="10" fontWeight="900" fontFamily="Montserrat, sans-serif" fill="#2f63f5">₴</text>
                        <path d="M17.5 7.5L22 12l-4.5 4.5" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                }
                title="Переказ балансу"
                text={<>Надішліть частину свого балансу іншому гравцю — потрібен лише його SteamID. На балансі зараз <b>{balance.toFixed(2)} ₴</b>.</>}
            />

            <div className="bc-field">
                <label className="bc-amount">
                    <input
                        className="bc-input"
                        type="number"
                        inputMode="decimal"
                        min="1"
                        step="1"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        aria-label="Сума переказу"
                    />
                    <span>₴</span>
                </label>
                <input
                    className="bc-input"
                    value={steamId}
                    onChange={(e) => setSteamId(e.target.value.replace(/\D/g, ""))}
                    placeholder="SteamID отримувача"
                    inputMode="numeric"
                    maxLength={17}
                    aria-label="SteamID отримувача"
                />
                <SpinButton loading={loading} disabled={!steamId || !amount}>Надіслати</SpinButton>
            </div>
        </form>
    );
};

export default TransferBlock;
